
<div
    class  = "mr-1 v-flex pa-1 doc-panel"
    @click = "onDocument"
>
    <div>
        <v-switch
            v-model       = "state"
            class         = "doc-switch"
            :hide-details = "true"
            :ripple       = "false"
            @change       = "onSelected"
            @click.native.stop
        />
    </div>
    <div style="display: block; padding-top: 3px;" class="pl-1 v-flex" >
        <div class="doc-info v-flex">
            <c-inc-document-icon
                class="pr-0"
                style="margin-top: -4px; max-height: 20px; margin-right: 2px;"
                :document = "document"
                :size = "22"
            />

            <!-- unit chip -->
            <div v-if="document.unitName" class="doc-unit mr-1 primary white--text">
                {{ document.unitName }}
            </div>
            <!-- unit chip -->

            <!-- bid chip -->
            <div v-if="document.bidId" class="primary white--text">
                {{ bidname }}
            </div>
            <!-- bid chip -->

            <div class="doc-execution" v-if="document.executionDate">
                {{ document.executionDate ? dateAsString ( document.executionDate) : '---'}}
            </div>

            <!-- document type -->
            <div>
                {{ document.type ? document.type.name : '---'}}
            </div>
            <!-- document type -->
        </div>

        <div class="doc-subinfo doc-filename">
            {{ document.name }}
        </div>
    </div>
</div>
